const BASE_NOTETAKER_ELIGIBLE_LOCATION_KINDS = new Set(['zoom_conference', 'google_conference'])

export const isNotetakerEligibleLocationKind = (kind, hasMsTeamsFlag = false) => {
  const eligibleKinds = new Set(BASE_NOTETAKER_ELIGIBLE_LOCATION_KINDS)
  if (hasMsTeamsFlag) {
    eligibleKinds.add('microsoft_teams_conference')
  }
  return eligibleKinds.has(kind)
}
